module.exports = __webpack_public_path__ + "static/media/snare.3a483bd7.ogg";